function _jade_template_fn(locals) {
  locals = locals || {};
  var h = require("panel").h;
  return h("canvas")
}
module.exports = _jade_template_fn;